import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import myAxios from '../AxiosUrl';
import styles from './Product.module.css';
import Pagination from '@mui/material/Pagination';
import {
    AiOutlineAppstore,
    AiOutlineBars,
    AiOutlineEdit,
    AiOutlineDelete,
    AiOutlineCopy,
} from 'react-icons/ai';
import { FiPackage } from 'react-icons/fi';
import 'react-toastify/dist/ReactToastify.css';
import SearchDesktopOptimized from '../Search/SearchDesktopOptimized';
import DeleteConfirmModal from './DeleteConfirmModal';

function ProductPage() {
    const uid = localStorage.getItem('id');
    const [products, setProduct] = useState([]);
    const [refresh, setRefresh] = useState();
    const navigate = useNavigate();
    const [loading, setloading] = useState(true);
    const [searchResult, setSearchResult] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [viewMode, setViewMode] = useState('list'); // 'grid' or 'list'

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const productsPerPage = 10;

    // Delete modal state
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);

    const AlartSubmit = (product) => {
        setProductToDelete(product);
        setDeleteModalOpen(true);
    };

    const deleteUser = (id) => {
        setDeleteModalOpen(false);
        setProductToDelete(null);
        myAxios
            .delete(`delete/${id}`)
            .then((res) => {
                if (res.data.success) {
                    setRefresh(Math.random());
                    toast.success(res.data.message || 'Product deleted successfully');
                } else {
                    toast.error(res.data.message || 'Failed to delete product');
                }
            })
            .catch((error) => {
                console.error('Delete error:', error);
                toast.error(error.response?.data?.message || 'Error deleting product');
            });
    };

    const duplicateProduct = (product) => {
        toast.info('Duplicating product...');
        myAxios
            .post(`duplicate-product/${product._id}`, { uid })
            .then((res) => {
                if (res.data.success) {
                    setRefresh(Math.random());
                    toast.success(
                        res.data.message || 'Product duplicated successfully'
                    );
                } else {
                    toast.error(
                        res.data.message ||
                            res.data.error ||
                            'Failed to duplicate product'
                    );
                }
            })
            .catch((error) => {
                console.error('Duplicate error:', error);
                toast.error(
                    error.response?.data?.error ||
                        error.response?.data?.message ||
                        'Error duplicating product'
                );
            });
    };

    useEffect(() => {
        if (searchResult.length > 0) return; // Skip server fetch while search is active
        setloading(true);
        myAxios
            .get(`get-products/${uid}?page=${currentPage}&limit=${productsPerPage}`)
            .then((res) => {
                if (res.data.success && res.data.data) {
                    setProduct(res.data.data);
                    setTotalPages(res.data.pagination?.totalPages || 0);
                    setTotalCount(res.data.pagination?.totalCount || 0);
                } else if (Array.isArray(res.data)) {
                    // Backward compat: old format returns array directly
                    setProduct(res.data);
                    setTotalPages(Math.ceil(res.data.length / productsPerPage));
                    setTotalCount(res.data.length);
                }
                setloading(false);
            })
            .catch((error) => {
                console.error('Fetch products error:', error.response);
                setloading(false);
            });
    }, [refresh, currentPage, uid]);

    // Handler for optimized search results
    const handleSearchResults = (results) => {
        if (results === null) {
            // Clear search - show all products
            setSearchResult([]);
        } else {
            // Show search results
            setSearchResult(results);
        }
        setCurrentPage(1);
    };

    const isSearching = searchResult.length > 0;
    const data = isSearching ? searchResult : products;

    // When using server-side pagination, products are already the current page
    const currentProducts = isSearching
        ? data.slice((currentPage - 1) * productsPerPage, currentPage * productsPerPage)
        : data;

    const paginationCount = isSearching
        ? Math.ceil(data.length / productsPerPage)
        : totalPages;

    // Handle pagination change
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                background: '#f3f4f6',
                padding: '0px',
            }}
        >
            <ToastContainer />
            <div
                style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '24px',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                }}
            >
                {/* Search and Filters */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '24px',
                        gap: '16px',
                        flexWrap: 'wrap',
                        background: '#f9fafb',
                        padding: '16px 20px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                    }}
                >
                    {loading ? (
                        <>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flex: 1 }}>
                                <div className={styles.skeleton} style={{ width: 120, height: 40, borderRadius: 8 }}></div>
                                <div className={styles.skeleton} style={{ flex: 1, maxWidth: 400, height: 40, borderRadius: 8 }}></div>
                            </div>
                            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                <div className={styles.skeleton} style={{ width: 90, height: 16 }}></div>
                                <div className={styles.skeleton} style={{ width: 130, height: 40, borderRadius: 8 }}></div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '12px',
                                    alignItems: 'center',
                                    flex: 1,
                                }}
                            >
                                {/* Add Product Button - FIRST */}
                                <Button
                                    variant="contained"
                                    onClick={() => navigate('/add-product')}
                                    style={{
                                        backgroundColor: '#008060',
                                        color: 'white',
                                        padding: '10px 20px',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontWeight: '500',
                                        boxShadow: 'none',
                                        fontSize: '14px',
                                        whiteSpace: 'nowrap',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#006e52';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#008060';
                                    }}
                                >
                                    Add product
                                </Button>
                                {/* Search Bar - SECOND */}
                                <div
                                    style={{
                                        flex: 1,
                                        maxWidth: '400px',
                                        minWidth: '250px',
                                    }}
                                >
                                    <SearchDesktopOptimized
                                        uid={uid}
                                        onSearchResults={handleSearchResults}
                                        onLoading={setSearchLoading}
                                    />
                                </div>
                            </div>
                            {/* Right Side - Product Count and View Toggle */}
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '12px',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#6d7175',
                                        fontWeight: '500',
                                    }}
                                >
                                    {isSearching ? data.length : totalCount} products
                                </div>
                                {/* View Toggle Buttons */}
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '4px',
                                        background: 'white',
                                        padding: '4px',
                                        borderRadius: '8px',
                                        border: '1px solid #e1e3e5',
                                    }}
                                >
                                    <button
                                        onClick={() => setViewMode('grid')}
                                        style={{
                                            padding: '8px 12px',
                                            border: 'none',
                                            background:
                                                viewMode === 'grid'
                                                    ? '#008060'
                                                    : 'transparent',
                                            color:
                                                viewMode === 'grid'
                                                    ? 'white'
                                                    : '#6d7175',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        <AiOutlineAppstore size={18} />
                                        Grid
                                    </button>
                                    <button
                                        onClick={() => setViewMode('list')}
                                        style={{
                                            padding: '8px 12px',
                                            border: 'none',
                                            background:
                                                viewMode === 'list'
                                                    ? '#008060'
                                                    : 'transparent',
                                            color:
                                                viewMode === 'list'
                                                    ? 'white'
                                                    : '#6d7175',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        <AiOutlineBars size={18} />
                                        List
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* Product Display - Grid or List */}
                {viewMode === 'grid' ? (
                    /* Grid View */
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '20px',
                            marginBottom: '32px',
                        }}
                    >
                        {loading && (
                            <>
                                {[1, 2, 3, 4, 5, 6].map((n) => (
                                    <div key={n} className={styles.skeletonCard}>
                                        <div className={`${styles.skeleton} ${styles.skeletonCardImage}`}></div>
                                        <div style={{ padding: 16 }}>
                                            <div className={`${styles.skeleton}`} style={{ width: '80%', height: 18, marginBottom: 12 }}></div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                                <div>
                                                    <div className={`${styles.skeleton}`} style={{ width: 70, height: 12, marginBottom: 4 }}></div>
                                                    <div className={`${styles.skeleton}`} style={{ width: 55, height: 16 }}></div>
                                                </div>
                                                <div>
                                                    <div className={`${styles.skeleton}`} style={{ width: 70, height: 12, marginBottom: 4 }}></div>
                                                    <div className={`${styles.skeleton}`} style={{ width: 55, height: 16 }}></div>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                                                <div className={`${styles.skeleton}`} style={{ width: 80, height: 14 }}></div>
                                                <div className={`${styles.skeleton}`} style={{ width: 60, height: 14 }}></div>
                                            </div>
                                            <div style={{ display: 'flex', gap: 8 }}>
                                                <div className={`${styles.skeleton}`} style={{ flex: 1, height: 36, borderRadius: 6 }}></div>
                                                <div className={`${styles.skeleton}`} style={{ flex: 1, height: 36, borderRadius: 6 }}></div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}

                        {!loading && currentProducts.length <= 0 ? (
                            <div
                                style={{
                                    gridColumn: '1 / -1',
                                    textAlign: 'center',
                                    padding: '60px 20px',
                                    color: '#6d7175',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '48px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    <FiPackage />
                                </div>
                                <h3
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#202223',
                                        margin: '0 0 8px 0',
                                    }}
                                >
                                    No products found
                                </h3>
                                <p
                                    style={{
                                        fontSize: '14px',
                                        margin: '0 0 24px 0',
                                    }}
                                >
                                    Get started by adding your first product
                                </p>
                                <Button
                                    variant="contained"
                                    onClick={() => navigate('/add-product')}
                                    style={{
                                        backgroundColor: '#008060',
                                        color: 'white',
                                        padding: '10px 16px',
                                        borderRadius: '6px',
                                        textTransform: 'none',
                                    }}
                                >
                                    Add product
                                </Button>
                            </div>
                        ) : (
                            currentProducts.map((product) => {
                                let quantity = 0;

                                if (product) {
                                    if (product.variation === 'color' && product.variationData) {
                                        product.variationData.forEach(
                                            (data) => {
                                                quantity += (data.quantity || 0) * 1;
                                            }
                                        );
                                    } else if (
                                        product.variation === 'colorSize' && product.variationData
                                    ) {
                                        product.variationData.forEach(
                                            (data) => {
                                                if (data.sizes && Array.isArray(data.sizes)) {
                                                    data.sizes.forEach((d) => {
                                                        quantity += (d.quantity || 0) * 1;
                                                    });
                                                }
                                            }
                                        );
                                    } else {
                                        quantity = product.quantity || 0;
                                    }
                                }

                                return (
                                    <div
                                        key={product._id}
                                        style={{
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            border: '1px solid #e1e3e5',
                                            overflow: 'hidden',
                                            transition: 'all 0.2s ease',
                                            cursor: 'pointer',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.boxShadow =
                                                '0 4px 12px rgba(0, 0, 0, 0.1)';
                                            e.currentTarget.style.transform =
                                                'translateY(-2px)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.boxShadow =
                                                'none';
                                            e.currentTarget.style.transform =
                                                'translateY(0)';
                                        }}
                                    >
                                        {/* Product Image */}
                                        <div
                                            style={{
                                                position: 'relative',
                                                height: '200px',
                                                backgroundColor: '#f6f6f7',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            <img
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                                src={
                                                    product.images && product.images[0] && product.images[0].url
                                                        ? product.images[0].url
                                                        : product.imageUrl || 'https://via.placeholder.com/200'
                                                }
                                                alt="product"
                                            />
                                            {/* Badges */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    left: '8px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '4px',
                                                }}
                                            >
                                                {product.Trending === '1' && (
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                '#ff6b35',
                                                            color: 'white',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            fontSize: '10px',
                                                            fontWeight: '600',
                                                            textTransform:
                                                                'uppercase',
                                                        }}
                                                    >
                                                        TREND
                                                    </span>
                                                )}
                                                {product.HotDeal === '1' && (
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                '#e74c3c',
                                                            color: 'white',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            fontSize: '10px',
                                                            fontWeight: '600',
                                                            textTransform:
                                                                'uppercase',
                                                        }}
                                                    >
                                                        HOT
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Product Info */}
                                        <div style={{ padding: '16px' }}>
                                            <h3
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#202223',
                                                    margin: '0 0 8px 0',
                                                    lineHeight: '1.4',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                {product.productName}
                                            </h3>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                    alignItems: 'center',
                                                    marginBottom: '12px',
                                                }}
                                            >
                                                <div>
                                                    <div
                                                        style={{
                                                            fontSize: '14px',
                                                            color: '#6d7175',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        Buying Price
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            color: '#202223',
                                                        }}
                                                    >
                                                        ৳{product.priceBuy}
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        textAlign: 'right',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: '14px',
                                                            color: '#6d7175',
                                                            marginBottom: '2px',
                                                        }}
                                                    >
                                                        Selling Price
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            color: '#008060',
                                                        }}
                                                    >
                                                        ৳{product.priceSell}
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'space-between',
                                                    alignItems: 'center',
                                                    marginBottom: '16px',
                                                    fontSize: '14px',
                                                    color: '#6d7175',
                                                }}
                                            >
                                                <div>
                                                    <strong>Color:</strong>{' '}
                                                    {product.color
                                                        ? product.color
                                                        : 'Edit to See'}
                                                </div>
                                                <div>
                                                    <strong>Stock:</strong>{' '}
                                                    {quantity}
                                                </div>
                                            </div>

                                            {/* Action Buttons */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '8px',
                                                }}
                                            >
                                                <button
                                                    onClick={() => {
                                                        navigate(
                                                            `/add-product/${product._id}`
                                                        );
                                                    }}
                                                    style={{
                                                        flex: 1,
                                                        backgroundColor:
                                                            '#008060',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        cursor: 'pointer',
                                                        transition:
                                                            'background-color 0.2s ease',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor =
                                                            '#006e52';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor =
                                                            '#008060';
                                                    }}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        duplicateProduct(product)
                                                    }
                                                    title="Duplicate product"
                                                    style={{
                                                        flex: 1,
                                                        backgroundColor:
                                                            '#5c6ac4',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '8px 8px',
                                                        borderRadius: '6px',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        cursor: 'pointer',
                                                        whiteSpace: 'nowrap',
                                                        transition:
                                                            'background-color 0.2s ease',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor =
                                                            '#4b57ad';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor =
                                                            '#5c6ac4';
                                                    }}
                                                >
                                                    Duplicate
                                                </button>
                                                <button
                                                    onClick={() =>
                                                        AlartSubmit(product)
                                                    }
                                                    style={{
                                                        flex: 1,
                                                        backgroundColor:
                                                            '#e74c3c',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        cursor: 'pointer',
                                                        transition:
                                                            'background-color 0.2s ease',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor =
                                                            '#c0392b';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor =
                                                            '#e74c3c';
                                                    }}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                ) : (
                    /* List View */
                    <TableContainer
                        component={Paper}
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #e1e3e5',
                            marginBottom: '32px',
                        }}
                    >
                        <Table>
                            <TableHead style={{ background: '#f8fafc' }}>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Image
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Product Name
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Buying Price
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Selling Price
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Color
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Stock
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                        }}
                                    >
                                        Status
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            fontWeight: '600',
                                            color: '#374151',
                                            textAlign: 'center',
                                        }}
                                    >
                                        Actions
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading && (
                                    <>
                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                                            <TableRow key={n}>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: 70, height: 70, borderRadius: 8 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: '75%', height: 16, marginBottom: 6 }}></div>
                                                    <div className={`${styles.skeleton}`} style={{ width: '45%', height: 12 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: 60, height: 16 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: 60, height: 16 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: 70, height: 14 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: 40, height: 16 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div className={`${styles.skeleton}`} style={{ width: 55, height: 24, borderRadius: 4 }}></div>
                                                </TableCell>
                                                <TableCell>
                                                    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                                                        <div className={`${styles.skeleton}`} style={{ width: 60, height: 32, borderRadius: 6 }}></div>
                                                        <div className={`${styles.skeleton}`} style={{ width: 65, height: 32, borderRadius: 6 }}></div>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </>
                                )}

                                {!loading && currentProducts.length <= 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={8}
                                            style={{
                                                textAlign: 'center',
                                                padding: '60px 20px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: '48px',
                                                    marginBottom: '16px',
                                                }}
                                            >
                                                <FiPackage />
                                            </div>
                                            <h3
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: '600',
                                                    color: '#202223',
                                                    margin: '0 0 8px 0',
                                                }}
                                            >
                                                No products found
                                            </h3>
                                            <p
                                                style={{
                                                    fontSize: '14px',
                                                    color: '#6d7175',
                                                    margin: '0 0 24px 0',
                                                }}
                                            >
                                                Get started by adding your first
                                                product
                                            </p>
                                            <Button
                                                variant="contained"
                                                onClick={() =>
                                                    navigate('/add-product')
                                                }
                                                style={{
                                                    backgroundColor: '#008060',
                                                    color: 'white',
                                                    padding: '10px 16px',
                                                    borderRadius: '6px',
                                                    textTransform: 'none',
                                                }}
                                            >
                                                Add product
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    currentProducts.map((product) => {
                                        let quantity = 0;

                                        if (product) {
                                            if (product.variation === 'color' && product.variationData) {
                                                product.variationData.forEach(
                                                    (data) => {
                                                        quantity +=
                                                            (data.quantity || 0) * 1;
                                                    }
                                                );
                                            } else if (
                                                product.variation ===
                                                'colorSize' && product.variationData
                                            ) {
                                                product.variationData.forEach(
                                                    (data) => {
                                                        if (data.sizes && Array.isArray(data.sizes)) {
                                                            data.sizes.forEach(
                                                                (d) => {
                                                                    quantity +=
                                                                        (d.quantity || 0) *
                                                                        1;
                                                                }
                                                            );
                                                        }
                                                    }
                                                );
                                            } else {
                                                quantity = product.quantity || 0;
                                            }
                                        }

                                        return (
                                            <TableRow
                                                key={product._id}
                                                style={{
                                                    transition: 'all 0.2s ease',
                                                    cursor: 'pointer',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background =
                                                        '#f8fafc';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background =
                                                        'white';
                                                }}
                                            >
                                                <TableCell>
                                                    <img
                                                        style={{
                                                            width: '70px',
                                                            height: '70px',
                                                            borderRadius: '8px',
                                                            objectFit: 'cover',
                                                            border: '2px solid #e5e7eb',
                                                        }}
                                                        src={
                                                            product.images && product.images[0] && product.images[0].url
                                                                ? product.images[0].url
                                                                : product.imageUrl || 'https://via.placeholder.com/70'
                                                        }
                                                        alt="product"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            fontWeight: '600',
                                                            color: '#202223',
                                                            maxWidth: '300px',
                                                        }}
                                                    >
                                                        {product.productName}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            fontWeight: '600',
                                                            color: '#202223',
                                                        }}
                                                    >
                                                        ৳{product.priceBuy}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            fontWeight: '600',
                                                            color: '#008060',
                                                        }}
                                                    >
                                                        ৳{product.priceSell}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            color: '#6d7175',
                                                        }}
                                                    >
                                                        {product.color
                                                            ? product.color
                                                            : 'Edit to See'}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            fontWeight: '600',
                                                            color:
                                                                quantity > 0
                                                                    ? '#008060'
                                                                    : '#e74c3c',
                                                        }}
                                                    >
                                                        {quantity}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            gap: '4px',
                                                        }}
                                                    >
                                                        {product.Trending ===
                                                            '1' && (
                                                            <span
                                                                style={{
                                                                    backgroundColor:
                                                                        '#ff6b35',
                                                                    color: 'white',
                                                                    padding:
                                                                        '4px 8px',
                                                                    borderRadius:
                                                                        '4px',
                                                                    fontSize:
                                                                        '10px',
                                                                    fontWeight:
                                                                        '600',
                                                                    textTransform:
                                                                        'uppercase',
                                                                    display:
                                                                        'inline-block',
                                                                    width: 'fit-content',
                                                                }}
                                                            >
                                                                TREND
                                                            </span>
                                                        )}
                                                        {product.HotDeal ===
                                                            '1' && (
                                                            <span
                                                                style={{
                                                                    backgroundColor:
                                                                        '#e74c3c',
                                                                    color: 'white',
                                                                    padding:
                                                                        '4px 8px',
                                                                    borderRadius:
                                                                        '4px',
                                                                    fontSize:
                                                                        '10px',
                                                                    fontWeight:
                                                                        '600',
                                                                    textTransform:
                                                                        'uppercase',
                                                                    display:
                                                                        'inline-block',
                                                                    width: 'fit-content',
                                                                }}
                                                            >
                                                                HOT
                                                            </span>
                                                        )}
                                                        {product.Trending !==
                                                            '1' &&
                                                            product.HotDeal !==
                                                                '1' && (
                                                                <span
                                                                    style={{
                                                                        color: '#6d7175',
                                                                        fontSize:
                                                                            '12px',
                                                                    }}
                                                                >
                                                                    Regular
                                                                </span>
                                                            )}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '8px',
                                                            justifyContent:
                                                                'center',
                                                        }}
                                                    >
                                                        <button
                                                            onClick={() => {
                                                                navigate(
                                                                    `/add-product/${product._id}`
                                                                );
                                                            }}
                                                            style={{
                                                                backgroundColor:
                                                                    '#008060',
                                                                color: 'white',
                                                                border: 'none',
                                                                padding:
                                                                    '8px 16px',
                                                                borderRadius:
                                                                    '6px',
                                                                fontSize:
                                                                    '13px',
                                                                fontWeight:
                                                                    '500',
                                                                cursor: 'pointer',
                                                                transition:
                                                                    'background-color 0.2s ease',
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                gap: '4px',
                                                            }}
                                                            onMouseEnter={(
                                                                e
                                                            ) => {
                                                                e.target.style.backgroundColor =
                                                                    '#006e52';
                                                            }}
                                                            onMouseLeave={(
                                                                e
                                                            ) => {
                                                                e.target.style.backgroundColor =
                                                                    '#008060';
                                                            }}
                                                        >
                                                            <AiOutlineEdit
                                                                size={16}
                                                            />
                                                            Edit
                                                        </button>
                                                        <button
                                                            onClick={() =>
                                                                duplicateProduct(
                                                                    product
                                                                )
                                                            }
                                                            style={{
                                                                backgroundColor:
                                                                    '#5c6ac4',
                                                                color: 'white',
                                                                border: 'none',
                                                                padding:
                                                                    '8px 16px',
                                                                borderRadius:
                                                                    '6px',
                                                                fontSize:
                                                                    '13px',
                                                                fontWeight:
                                                                    '500',
                                                                cursor: 'pointer',
                                                                transition:
                                                                    'background-color 0.2s ease',
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                gap: '4px',
                                                            }}
                                                            onMouseEnter={(
                                                                e
                                                            ) => {
                                                                e.target.style.backgroundColor =
                                                                    '#4b57ad';
                                                            }}
                                                            onMouseLeave={(
                                                                e
                                                            ) => {
                                                                e.target.style.backgroundColor =
                                                                    '#5c6ac4';
                                                            }}
                                                        >
                                                            <AiOutlineCopy
                                                                size={16}
                                                            />
                                                            Duplicate
                                                        </button>
                                                        <button
                                                            onClick={() =>
                                                                AlartSubmit(
                                                                    product
                                                                )
                                                            }
                                                            style={{
                                                                backgroundColor:
                                                                    '#e74c3c',
                                                                color: 'white',
                                                                border: 'none',
                                                                padding:
                                                                    '8px 16px',
                                                                borderRadius:
                                                                    '6px',
                                                                fontSize:
                                                                    '13px',
                                                                fontWeight:
                                                                    '500',
                                                                cursor: 'pointer',
                                                                transition:
                                                                    'background-color 0.2s ease',
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                gap: '4px',
                                                            }}
                                                            onMouseEnter={(
                                                                e
                                                            ) => {
                                                                e.target.style.backgroundColor =
                                                                    '#c0392b';
                                                            }}
                                                            onMouseLeave={(
                                                                e
                                                            ) => {
                                                                e.target.style.backgroundColor =
                                                                    '#e74c3c';
                                                            }}
                                                        >
                                                            <AiOutlineDelete
                                                                size={16}
                                                            />
                                                            Delete
                                                        </button>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {/* Pagination */}
                {!loading && paginationCount > 1 && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '32px',
                        }}
                    >
                        <Pagination
                            count={paginationCount}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="primary"
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    color: '#6d7175',
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#008060',
                                    color: 'white',
                                },
                            }}
                        />
                    </div>
                )}
            </div>

            {/* Delete Confirmation Modal */}
            <DeleteConfirmModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={() => productToDelete && deleteUser(productToDelete._id)}
                productName={productToDelete?.productName}
            />
        </div>
    );
}

export default ProductPage;
